import { useEffect, useState } from "react";
import { apiDashboard } from "../lib/api";
import { useFilters } from "../context/FiltersContext";

/** @param {string} module endpoint name (overview, projects, ...)
 *  @param {object} extraParams optional extra query params (e.g., {allocation_rule:'income'}) */
export const useDashboard = (module, extraParams = null) => {
  const { dateFrom, dateTo, refreshKey, selectedCompanyIds, companies } = useFilters();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cached, setCached] = useState(false);

  // Stringify extras to use as a stable dependency
  const extraKey = extraParams ? JSON.stringify(extraParams) : "";

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const params = { date_from: dateFrom, date_to: dateTo };
    if (selectedCompanyIds && selectedCompanyIds.length && selectedCompanyIds.length < companies.length) {
      params.company_ids = selectedCompanyIds.join(",");
    }
    if (extraParams) Object.assign(params, extraParams);
    apiDashboard(module, params)
      .then((res) => {
        if (cancelled) return;
        setData(res.data);
        setCached(!!res.cached);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e?.response?.data?.detail || e.message || "Error al cargar datos");
      })
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [module, dateFrom, dateTo, refreshKey, selectedCompanyIds, companies.length, extraKey]);

  return { data, loading, error, cached };
};
